import * as React from 'react';
import './SpsIntercom.scss';

function truncateNumber(number) {
  const num = parseFloat(number);
  if (num > 99) {
    return '99 +';
  }
  // for consistency sake, we will always return a string representation of a number
  return num.toString();
}

export default function SpsIntercom(props) {
  const [unreadMessages, setUnreadMessages] = React.useState(0);

  const handleOnChange = (e) => {
    window['Intercom']('show');
    e.preventDefault();
    e.stopPropagation();
  };

  React.useEffect(() => {
    window['Intercom']('onUnreadCountChange', (unreadCount) => {
      setUnreadMessages(unreadCount);
    });
  }, []);

  return (
    <div className='sps-intercom-dropdown' data-testid='sps-intercom'>
      <a
        id='sps-intercom-launcher'
        href='#'
        className='sps-intercom-dropdown-link'
        onClick={handleOnChange}
      >
        <div className='sps-intercom-dropdown-wrapper clearfix'>
          <i className='sps-icon sps-icon-intercom' style={{ lineHeight: '2.5' }} />
          {unreadMessages > 0 && (
            <span className='sps-intercom-dropdown__unread-message-counter'>
              {truncateNumber(unreadMessages)}
            </span>
          )}
        </div>
      </a>
    </div>
  );
}
